// ─── Chronik: wie das Buch geordnet ist ──────────────────────────────────────
//
// Die Reihenfolge entscheidet, wozu die Chronik taugt. Nach Generationen liest
// sie sich als Familiengeschichte, alphabetisch als Nachschlagewerk, nach
// Geburtsjahr als Zeitleiste. Deshalb ist es eine Wahl und keine Festlegung.

export const CHRONIK_SORTIERUNGEN = ['generationen', 'alphabetisch', 'geburtsjahr'] as const;

export type ChronikSortierung = (typeof CHRONIK_SORTIERUNGEN)[number];

export const CHRONIK_SORTIERUNG_LABELS: Record<ChronikSortierung, string> = {
  generationen: 'Nach Generationen',
  alphabetisch: 'Alphabetisch',
  geburtsjahr: 'Nach Geburtsjahr',
};

/**
 * Was ein Kapitel ist – kurz genug, um in einem Menüeintrag zu stehen.
 * Das Warum steht im Titel selbst; hier zählt, wonach geschnitten wird.
 */
export const CHRONIK_SORTIERUNG_BESCHREIBUNG: Record<ChronikSortierung, string> = {
  generationen: 'Ein Kapitel je Generation',
  alphabetisch: 'Ein Kapitel je Anfangsbuchstabe',
  geburtsjahr: 'Ein Kapitel je Jahrhundert',
};

export function istChronikSortierung(wert: unknown): wert is ChronikSortierung {
  return (
    typeof wert === 'string' && (CHRONIK_SORTIERUNGEN as readonly string[]).includes(wert)
  );
}
